import api from '../config/api';

export const login = async (username, password) => {
  const res = await api.post('/auth/login', { email: username, password });
  return res.data;
};

export const logout = async () => {
  const res = await api.post('/auth/logout');
  return res.data;
};

export const getMe = async () => {
  const res = await api.get('/auth/me');
  return res.data;
};
